import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
import "../css/pagination.css";
import moment from "moment/moment";
import axios from "axios";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { BiInfoCircle } from "react-icons/bi";
import { BsCaretDownFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const PER_PAGE = 25;

const TransactionsAll = () => {
  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);  
  const [q, setQ] = useState("");
  const list = [
    "stripe_clearing",
    "manual_clearing",
    "seller_holding",
    "seller_disputed",
    "seller_payable",
    "seller_payout",
    "seller_pending",
    "platform_refund",
    "platform_revenue",
  ];
  function searchData() {

    return Data.filter((transaction) => {
      if (q === "") {
        return transaction;
      } else if (transaction?.account.toLowerCase().includes(q.toLowerCase())) {
        return transaction;
      }
    });
  }
  const fetchRequests = () => {
    var config = {
      method: "get",
      url: Server2 + "/admin/get-all-transactions",
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {	
    setLoading(true);
    fetchRequests();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, (text) => {
      return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
    });
  }

  const splitTwo = (str) => {
    return str.split('_').length < 2 ? str : toTitleCase(str.split('_')[0]) + " " + toTitleCase(str.split('_')[1])
  }

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData =
    Data.length === 0
      ? null
      : searchData()
          .slice(offset, offset + PER_PAGE)
          .map((transaction, index) => (
            <tbody key={index}>
              <tr>
                <td className="ps-2">
                  <div className="d-flex px-2 py-1 cursor-pointer" onClick={() => navigate(`/profile/${transaction?.userId?._id}`, { state: { item: transaction.userId?._id } })}>
                    <div>
                      <img
                        src={
                          transaction.userId?.profile_pic
                            ? transaction.userId?.profile_pic
                            : "/logoi192.png"
                        }
                        className="avatar avatar-sm me-3"
                        alt="user1"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-stretch">
                      <h6 className="mb-0 text-sm text-capitalize ">
                        {transaction.userId?.fname ? transaction.userId?.fname : "iBouge"}
                      </h6>
                      <p className="text-xs text-secondary mb-0">
                        {transaction.userId?.email}
                      </p>
                    </div>
                  </div>
                </td>
                <td className="align-middle">
                  <p className="text-secondary fw-bold ">{splitTwo(transaction.account)}</p>
                </td>
                <td className="align-middle">
                  <p className="text-secondary fw-bold ">{splitTwo(transaction.type)}</p>
                </td>
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{transaction.credit.toFixed(3)}</p>
                </td>
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{transaction.debit.toFixed(3)}</p>
                </td>
                <td className="align-middle">
                  <p className="">
                    {moment(transaction.createdAt).format("MMMM Do, YYYY  h:mm A")}
                  </p>
                </td>
                <td className="align-middle">
                  <BiInfoCircle title={transaction.note}/>
                </td>
              </tr>
            </tbody>
          )).reverse();

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="card-header pb-0">
                    <h6>All Transactions Ledger</h6>
                  </div>
                  <div
                    className="card-body px-0 pt-0 pb-2 task"
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <div className="table-responsive p-0">
                      <table className="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th className="text-uppercase">User</th>
                            <th className="ps-2">
                              <Dropdown className="ms-0">
                                <Dropdown.Toggle
                                  className="border-0 p-0"
                                  variant=""
                                  id="dropdown-basic"
                                  aria-expanded="false"
                                >
                                  <span
                                    className="fs-6 fw-bold text-uppercase"
                                    style={{ color: "#67748e" }}
                                  >
                                    Account{" "}
                                    <BsCaretDownFill size={12}/>
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu">
                                <Dropdown.Item
                                  onClick={() => {
                                    setQ("");
                                  }}
                                >
                                  <span className="fw-bold">
                                    Show All
                                  </span>
                                </Dropdown.Item>
                                  {
                                    list.map((e) =>{
                                      return(
                                          <Dropdown.Item
                                          onClick={() => {
                                            setQ(e);
                                          }}
                                        >
                                          <span className="fw-bold">
                                            {splitTwo(e)}
                                          </span>
                                        </Dropdown.Item>
                                      )
                                    })
                                  }
                                </Dropdown.Menu>
                              </Dropdown>
                            </th>
                            <th className="text-uppercase ps-1">Type</th>
                            <th className="text-uppercase text-center">Credit</th>
                            <th className="text-uppercase text-center">Debit</th>
                            <th className="text-uppercase ps-3">Last Processed</th>
                          </tr>
                        </thead>
                        {currentPageData}
                      </table>
                    </div>

                    {searchData().length > 24 ? (
                      <div
                        className=" mt-4"
                        style={{
                          padding: 2,
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={
                            <MdOutlineNavigateNext
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={
                            <GrFormPrevious
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TransactionsAll;
